export default {
  controls: [
    {
      title: 'controls.folding_of_middle_siderails',
      icon: 'icon-foot-siderails-essenza',
      animation: 'folding_of_foot_siderails',
      autoHideLabel: true,
      checkTransferMode: true,
      toggle: true
    },
    {
      title: 'controls.folding_of_head_siderails',
      icon: 'icon-head-siderails-essenza',
      animation: 'folding_of_head_siderails',
      autoHideLabel: true,
      toggle: true
    },
    {
      title: 'controls.mobilift',
      icon: 'icon-mobilift',
      animation: 'mobilift',
      autoHideLabel: true,
      toggle: true
    }
  ],
  solutions: [
    {
      title: 'solutions.safety_and_ergonomics',
      style: 'thumbnails',
      image: 'superior-safety-and-ergonomics.jpg',
      explanation: 'safety_and_ergonomics'
    },
    {
      title: 'solutions.single_platform',
      style: 'thumbnails',
      image: 'efficiency-of-a-single-platform.jpg',
      explanation: 'single_platform'
    },
    {
      title: 'solutions.advanced_technologies',
      style: 'thumbnails',
      image: 'unparalleled-effectiveness.jpg',
      explanation: 'advanced_technologies'
    }
  ],
  keyFeatures: [
    {
      title: 'key_features.mobilization',
      style: 'thumbnails',
      image: 'safety.jpg',
      explanation: 'mobilization',
    },
    {
      title: 'key_features.transportation',
      style: 'thumbnails',
      image: 'transportation.jpg',
      explanation: 'transportation',
    },
    {
      title: 'key_features.additional_controls',
      style: 'thumbnails',
      image: 'additional_controls.jpg',
      explanation: 'additional_controls',
    },
    {
      title: 'key_features.comfort',
      style: 'thumbnails',
      image: 'ergoframe.jpg',
      explanation: 'comfort',
    }
  ],
  modifications: [
    {
      title: 'modifications.texture',
      icon: 'icon-colors',
      options: {
        style: 'vertical',
        default: 0,
        items: [
          {
            title: 'modifications.texture.none',
            image: 'no-texture.png',
            modelParts: [
              {
                name: 'postranice_zada_geo2Shape_2',
                texture: null
              }
            ]
          },
          {
            title: 'modifications.texture.ess_meteorites',
            image: 'meteorits.png',
            modelParts: [
              {
                name: 'postranice_zada_geo2Shape_2',
                texture: 'essenza_meteorit.png'
              }
            ]
          },
          {
            title: 'modifications.texture.ess_blue',
            image: 'blue.png',
            modelParts: [
              {
                name: 'postranice_zada_geo2Shape_2',
                texture: 'essenza_blue.png'
              }
            ]
          },
          {
            title: 'modifications.texture.ess_red',
            image: 'red.png',
            modelParts: [
              {
                name: 'postranice_zada_geo2Shape_2',
                texture: 'essenza_ny.png'
              }
            ]
          }
        ]
      }
    },
    {
      title: 'modifications.mattress',
      icon: 'icon-mattress',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.mattress.with_mattress',
            image: 'modifications--with_mattras.jpg',
            modelParts: [
              {
                name: 'matrace_geoPIV',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.mattress.without_mattress',
            image: 'modifications--without_mattras.jpg',
            modelParts: [
              {
                name: 'matrace_geoPIV',
                visible: false
              }
            ]
          }
        ]
      }
    }
  ]
}